import { View } from 'react-native';
import React from 'react';
import { BlastView } from '@ologyhealth/wp-components';
import { useNavigate } from '../../react-router';


export default function BlastViewLandingPage(): JSX.Element {
  const navigate = useNavigate();

  const openTryNow = () => {
    navigate('/register');
  }

  const onLogin = () => {
    navigate('/login')
  }

  return (
    <View style={{ flex: 1, justifyContent: 'center' }}>
      <BlastView
        title="Exclusive content subscriptions for your followers"
        description="Like a text message-based Patreon but 100x simpler to set up and manage."
        onLogin={onLogin}
        onGetStarted={openTryNow}
      />
    </View>
  );
}
